// Discarding a change set that has not been applied (zou DiscardChangeSet),
// from the Modification Center and the award comparison page.
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { apiErrorMessage } from '../../../../lib/api/apiErrorMessage';
import { projectDataClient } from '../../../../lib/connect/clients';
const DISCARD_PREVIEW_KEY = 'discard-change-set-preview';
/**
 * Whether the caller may discard the set and whether its uploaded document can
 * go with it; read fresh each time the dialog opens, never from cache.
 */ export function useDiscardPreview(changeSetId, enabled) {
    return useQuery({
        queryKey: [
            DISCARD_PREVIEW_KEY,
            changeSetId
        ],
        enabled: enabled && !!changeSetId,
        staleTime: 0,
        gcTime: 0,
        queryFn: ()=>projectDataClient.previewDiscardChangeSet({
                changeSetId
            })
    });
}
export function useDiscardChangeSet() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (args)=>projectDataClient.discardChangeSet(args),
        onSuccess: (resp, vars)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'program-change-sets'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'change-set-discrepancies',
                    vars.changeSetId
                ]
            });
            if (resp.documentRemoved) {
                queryClient.invalidateQueries({
                    queryKey: [
                        'program document'
                    ]
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        'projectFiles'
                    ]
                });
            }
        },
        onError: (err)=>{
            toast.error(apiErrorMessage(err, 'Failed to discard the change set'));
        }
    });
}
